import PropTypes from 'prop-types'
import { ProgressBarFooterContainer } from '../styled-components'

const ProgressBarFooter = ({ hideLabel, children }) => {
  return (
    !hideLabel && (
      <ProgressBarFooterContainer>{children}</ProgressBarFooterContainer>
    )
  )
}

ProgressBarFooter.propTypes = {
  hideLabel: PropTypes.bool,
  children: PropTypes.node
}

export default ProgressBarFooter
